import type { IAccessTokenProvider } from "../../application/interfaces/IAccessTokenProvider";
import type { ICourseRepository } from "../../application/interfaces/ICourseRepository";
import type { CourseDto } from "../../shared/CourseDto";
import type { IApiSearchResponse } from "../../abstractions/IApiSearchResponse";
import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";
import type { CourseLessonDto } from "../../shared/CourseLessonDto";

export class CourseRepository implements ICourseRepository {

  readonly configProvider: IAppConfigProvider;
  readonly tokenProvider: IAccessTokenProvider;

  constructor(configProvider: IAppConfigProvider, tokenProvider: IAccessTokenProvider) {
    this.configProvider = configProvider;
    this.tokenProvider = tokenProvider;
  }

  async findById(courseId: number): Promise<CourseDto | null> {
    const token = await this.tokenProvider.getAccessToken();
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const url = `${config.apiUrl}/Course/${courseId}`;
    const response = await fetch(url, {
      headers,
    });
    let result = await response.json();

    return result as CourseDto;
  }

  async getLessons(courseId: number): Promise<CourseLessonDto[]> {
    const token = await this.tokenProvider.getAccessToken();
    const config = await this.configProvider.getAppConfig();
    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const url = `${config.apiUrl}/Course/${courseId}/Lesson`;
    const response = await fetch(url, {
      headers,
    });
    let result = await response.json() as CourseLessonDto[];
    return result;
  }

  async search(
    courseCategoryId: number | null,
    search: string,
    page: number,
    perPage: number,
    sortBy: string,
    sortDesc: boolean,
  ): Promise<IApiSearchResponse<CourseDto>> {
    const token = await this.tokenProvider.getAccessToken();
    const config = await this.configProvider.getAppConfig();

    const headers: Record<string, string> = {
      "X-Api-Key": config.apiKey,
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    let url = `${config.apiUrl}/Course?page=${page}&perPage=${perPage}&sortBy=${encodeURIComponent(sortBy)}`;
    url+= "&isPublished=true"
    url+= "&coursePhaseFilter=Future"
    if (sortDesc) {
      url += "&sortDir=DESC";
    } else {
      url += "&sortDir=ASC";
    }
    if (search.trim() != "") {
      url += "&search=" + encodeURIComponent(search);
    }
    if (courseCategoryId != null) {
      url += `&courseCategoryId=${courseCategoryId}`;
    }
    const response = await fetch(url, {
      headers,
    });
    let result = (await response.json()) as IApiSearchResponse<CourseDto>;
    return result;
  }
}

